<p-dialog
  [header]="title"
  [visible]="isVisible"
  [modal]="true"
  [closable]="!isLoading"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '40rem', maxWidth: '90vw' }"
  (onHide)="onCancelClick()"
>
  @if (form) {
    <form [formGroup]="form" autocomplete="off">
      <div formArrayName="formFields">
        @for (field of fields; track field; let i = $index) {
          <div class="mb-4 flex flex-col gap-1">
            <label
              [for]="field.inputLabel"
              class="typography-labels-medium-emphasis"
              >{{ field.inputLabel }}</label
            >
            @if (field.inputType === "dropdown") {
              <p-select
                class="w-full"
                #modalInput
                [formControlName]="i"
                [inputId]="field.inputLabel"
                [options]="getDropdownOptions(field)"
                optionLabel="label"
                optionValue="value"
                (onChange)="customErrors[field.inputLabel] = []"
                [class.p-invalid]="
                  (formSubmitted || formControls[i].touched) &&
                  (formControls[i].errors ||
                    customErrors[field.inputLabel].length > 0)
                "
                [tabindex]="i + 1"
              />
            }
            @if (field.inputType === "boolean") {
              <p-checkbox
                [inputId]="field.inputLabel"
                #modalInput
                [binary]="true"
                [formControlName]="i"
                (onChange)="customErrors[field.inputLabel] = []"
                [tabindex]="i + 1"
              />
            }
            @if (field.inputType === "textarea") {
              <textarea
                pTextarea
                class="w-full"
                [placeholder]="field.placeholder"
                [id]="field.inputLabel"
                #modalInput
                [formControlName]="i"
                (change)="customErrors[field.inputLabel] = []"
                [invalid]="
                  (formSubmitted || formControls[i].touched) &&
                  (formControls[i].errors ||
                    customErrors[field.inputLabel].length > 0)
                "
                [attr.tabindex]="i + 1"
              ></textarea>
            }
            @if (field.inputType === "file") {
              <p-fileupload
                mode="basic"
                #modalInput
                [customUpload]="true"
                chooseIcon="pi pi-upload"
                chooseLabel="Choose file"
                [accept]="field.accept"
                (onSelect)="
                  handleFileSelection($event, i);
                  customErrors[field.inputLabel] = []
                "
                [tabindex]="i + 1"
              />
            }
            @if (field.inputType === "text" || field.inputType === "email") {
              <input
                pInputText
                [placeholder]="field.placeholder"
                [id]="field.inputLabel"
                #modalInput
                class="w-full"
                [type]="field.inputType"
                [formControlName]="i"
                [pattern]="field.pattern"
                (keydown)="customErrors[field.inputLabel] = []"
                [invalid]="
                  (formSubmitted || formControls[i].touched) &&
                  (formControls[i].errors ||
                    customErrors[field.inputLabel].length > 0)
                "
                [attr.tabindex]="i + 1"
              />
            }
            @if (field.inputType === "float") {
              <input
                pInputText
                [placeholder]="field.placeholder"
                [id]="field.inputLabel"
                #modalInput
                class="hide-number-input-arrows w-full"
                type="number"
                inputmode="decimal"
                step="0.0000000001"
                [formControlName]="i"
                (change)="customErrors[field.inputLabel] = []"
                (keydown)="restrictInvalidCharacters($event)"
                [invalid]="
                  (formSubmitted || formControls[i].touched) &&
                  (formControls[i].errors ||
                    customErrors[field.inputLabel].length > 0)
                "
                [attr.tabindex]="i + 1"
              />
            }
            @if (field.inputType === "ng-select") {
              <ng-select
                #modalInput
                [formControlName]="i"
                [id]="field.inputLabel"
                [items]="field.ngSelectConfigs.options"
                [bindLabel]="field.ngSelectConfigs.bindLabel"
                [bindValue]="field.ngSelectConfigs.bindValue"
                [placeholder]="
                  field.placeholder ? field.placeholder : 'Select an option'
                "
                appendTo="body"
                [multiple]="false"
                [closeOnSelect]="true"
                [clearable]="false"
                (change)="customErrors[field.inputLabel] = []"
                [searchable]="false"
                [attr.tabindex]="i + 1"
              >
                <!-- Customizes the look of each item in the dropdown if a template was provided -->
                @if (field.ngSelectConfigs.optionsTemplate) {
                  <ng-template ng-option-tmp let-item="item">
                    <ng-container
                      *ngTemplateOutlet="
                        field.ngSelectConfigs.optionsTemplate;
                        context: { $implicit: item }
                      "
                    />
                  </ng-template>
                }
                <!-- Customizes the look of the selected item if a template was provided -->
                @if (field.ngSelectConfigs.labelTemplate) {
                  <ng-template ng-label-tmp let-item="item">
                    <ng-container
                      *ngTemplateOutlet="
                        field.ngSelectConfigs.labelTemplate;
                        context: { $implicit: item }
                      "
                    />
                  </ng-template>
                }
              </ng-select>
            }
            @if (
              field.inputType === "infoMessage" ||
              field.inputType === "bannerMessage"
            ) {
              <ag1-banner [message]="field.message" [isDismissible]="false" />
            }
            @if (
              (formSubmitted || formControls[i].touched) &&
              formControls[i].errors
            ) {
              @if (formControls[i].errors.required) {
                <p-message severity="error" size="small" variant="simple"
                  >{{ field.inputLabel }} is required.</p-message
                >
              }
              @if (formControls[i].errors.email) {
                <p-message severity="error" size="small" variant="simple"
                  >Please enter a valid email address.</p-message
                >
              }
              @if (formControls[i].errors.minlength) {
                <p-message severity="error" size="small" variant="simple">
                  {{ field.inputLabel }} cannot be shorter than
                  {{ field.minLength }}
                  characters.
                </p-message>
              }
              @if (formControls[i].errors.maxlength) {
                <p-message severity="error" size="small" variant="simple">
                  {{ field.inputLabel }} cannot be longer than
                  {{ field.maxLength }}
                  characters.
                </p-message>
              }
              @if (formControls[i].errors.min) {
                <p-message severity="error" size="small" variant="simple">
                  {{ field.inputLabel }} cannot be smaller than {{ field.min }}.
                </p-message>
              }
              @if (formControls[i].errors.max) {
                <p-message severity="error" size="small" variant="simple">
                  {{ field.inputLabel }} cannot be larger than {{ field.max }}.
                </p-message>
              }
              @if (formControls[i].errors.pattern) {
                <p-message severity="error" size="small" variant="simple">
                  {{ patternValidationMessage }}
                </p-message>
              }
              <!-- Add new validation here -->
            }
            <!-- Custom errors-->
            @if (customErrors[field.inputLabel].length > 0) {
              @for (error of customErrors[field.inputLabel]; track error) {
                <p-message severity="error" size="small" variant="simple">{{
                  error
                }}</p-message>
              }
            }
            <!--End custom errors-->
          </div>
        }
      </div>
    </form>
  }

  <ng-template #footer>
    <p-button
      type="button"
      size="small"
      label="Cancel"
      severity="contrast"
      variant="text"
      (onClick)="onCancelClick()"
      [disabled]="isLoading"
    />
    <p-button
      type="button"
      size="small"
      [label]="confirmBtnText"
      [severity]="confirmButtonSeverity"
      [loading]="isLoading"
      [disabled]="!form || !(form.dirty || formDirty)"
      (onClick)="onConfirmClick()"
    />
  </ng-template>
</p-dialog>
